import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import configureStore from './configureStore';
import Root from './containers/Root';

import './index.css';

// для firefox неправильно работает автоматический scroll, поэтому необходимо отключить попытку бразуера сохранять
// положение scroll
window.history.scrollRestoration = 'manual';

configureStore().then((store) => {
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(
    <BrowserRouter>
      <Root store={store} />
    </BrowserRouter>
  );

  /*
     Read the details thoroughly before enabling it
     registerServiceWorker();
     */
});
